/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-11 20:19
 * @LastEditors: wenbin.ma@ginlong.com
 * @LastEditTime: 2026-07-28 17:35
 * @FilePath: \glyun_web_vue3\src\router\service.js
 * @Description: 服务路由
 */
export default [
  {
    path: '/service',
    redirect: '/service/powerStationReport',
    name: 'service',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//电站管理
        path: 'powerStationManagement',
        name: 'servicePowerStationManagement',
        component: () => import('../views/service/powerStationManagement/index.vue'),
        meta: {
          title: 'v2_service_plantmanage_plant_management',
          routeAuthCode: 'A0501',
        }
      },
      {//设备管理
        path: 'deviceManagement',
        name: 'serviceDeviceManagement',
        component: () => import('../views/service/deviceManagement/index.vue'),
        meta: {
          title: 'v2_service_device_device_management',
          routeAuthCode: 'A0502',
        }
      },
      {//组织管理
        path: 'orgManagement',
        name: 'serviceOrgManagement',
        component: () => import('../views/service/orgManagement/index.vue'),
        meta: {
          title: 'v2_service_organization_management',
          routeAuthCode: 'A0503',
        }
      },
      {//质保服务
        path: 'warrantyService',
        name: 'serviceWarrantyService',
        // component: () => import('../views/service/warrantyService/index.vue'),
        children: [
          {//延保订单
            path: 'extendedWarrantyOrders',
            name: 'serviceWarrantyServiceExtendedWarrantyOrders',
            component: () => import('../views/service/extendedWarranty/login/warrantyOrdersLogin.vue'),
            meta: {
              title: 'v2_extended_warranty_extended_warranty_order',
              routeAuthCode: 'A051701'
            }
          },
          {//质保查询
            path: 'warrantyQuery',
            name: 'serviceWarrantyServiceWarrantyQuery',
            component: () => import('../views/service/extendedWarranty/login/warrantyQueryLogin.vue'),
            meta: {
              title: 'v2_service_extend_warranty_warranty_enquiry',
              routeAuthCode: 'A051801'
            }
          },
          { //创建延保订单
            path: 'createExtendedWarrantyOrder',
            component: () => import('../views/service/extendedWarranty/login/createOrderLogin.vue'),
            meta: {
              title: 'v2_service_extend_warranty_create_order'
            }
          },
        ]
      },
      {//我的订单
        path: 'myOrder',
        name: 'serviceMyOrder',
        children: [
          {//延保订单
            path: 'warrantyOrder',
            name: 'serviceMyOrderWarrantyOrder',
            component: () => import('../views/service/myOrder/warrantyOrder/index.vue'),
            meta: {
              title: 'v2_service_extend_warranty_warranty_enquiry',
              routeAuthCode: 'A051701'
            },
          },
          {//服务=》延保订单详情
            path: 'warrantyOrder/orderDetail/:orderId',
            name: 'serviceExtendedWarrantyOrderDetail',
            component: () => import('../views/service/extendedWarranty/common/orderDetail.vue'),
            meta: {
              title: 'v2_early_warning_details',
            },
            beforeEnter:(to,from)=>{
              // orderSource区分是 官网还是 锦浪云的订单
              if(to.query?.orderSource == 3) {
                return `/officialWebsite/extendedWarrantyOrderDetail/${to.params.orderId}`
              }
            },
          },
          {//流量充值订单
            path: 'trafficRechargeOrder',
            name: 'serviceMyOrdertrafficRechargeOrder',
            component: () => import('../views/service/myOrder/trafficRechargeOrder/index.vue'),
            meta: {
              title: 'v2_data_top_up_order',
              routeAuthCode: 'A051702'
            }
          },
          // {//流量充值订单-详情
          //   path: 'trafficRechargeOrderDetail/:orderId',
          //   name: 'serviceMyOrdertrafficRechargeOrderDetail',
          //   component: () => import('../views/service/extendedWarranty/common/orderDetail.vue'),
          //   meta: {
          //     title: '订单详情',
          //     routeAuthCode: 'A051301'
          //   }
          // },
        ]
      },
      {//绑定SIM卡
        path: 'bindSimCard',
        name: 'serviceBindSimCard',
        component: () => import('../views/service/commonTools/bindSimCard/index.vue'),
        meta: {
          title: 'v2_router_label31',
          routeAuthCode: 'A051802'
        }
      },
      {//常用工具
        path: 'commonTools',
        name: 'serviceCommonTools',
        children: [
          // {//质保查询
          //   path: 'warrantyQuery',
          //   name: 'serviceWarrantyQuery',
          //   component: () => import('../views/service/warrantyQuery/index.vue'),
          //   meta: {
          //     title: 'v2_service_extend_warranty_warranty_enquiry',
          //     routeAuthCode: 'A0504',
          //   }
          // },
          {//质保查询
            path: 'warrantyQuery',
            name: 'serviceCommonToolsWarrantyQuery',
            component: () => import('../views/service/commonTools/warrantyQuery/index.vue'),
            meta: {
              title: 'v2_service_extend_warranty_warranty_enquiry',
              routeAuthCode: 'A051801'
            }
          },
          {//SIM卡绑定
            path: 'bindSimCard',
            name: 'serviceCommonToolsBindSimCard',
            component: () => import('../views/service/commonTools/bindSimCard/index.vue'),
            meta: {
              title: 'v2_router_label31',
              routeAuthCode: 'A051802'
            }
          },
          {//电池固件
            path: 'batteryFirmware/:inOut',
            name: 'serviceCommonToolsBatteryFirmware',
            component: () => import('../views/service/commonTools/batteryFirmware/index.vue'),
            meta: {
              title: 'v2_equipment_upgrade_battery_firmware',
              routeAuthCode: 'A051803',
            }
          },
           {//电池固件详情
            path: 'batteryFirmware/detail/:id/:inOut',
            name: 'serviceCommonToolsBatteryFirmwareDetail',
            component: () => import('../views/service/commonTools/batteryFirmware/components/firmwareDetail.vue'),
            meta: {
              title: 'v2_ota_firmware_details',
            }
          },
          {//DNSP注册
            path: 'dnspRegister',
            name: 'serviceCommonToolsDnspRegister',
            component: () => import('../views/service/commonTools/dnspRegister/index.vue'),
            meta: {
              title: 'v2_dnsp_register',
              routeAuthCode: 'A051804',
            },
          },
        ]
      },
      {//帮助中心
        path: 'helpCenter',
        name: 'serviceHelpCenter',
        children: [
          {//产品资料
            path: 'productInformation',
            name: 'serviceProductInformation',
            component: () => import('../views/service/helpCenter/productInformation/index.vue'),
            meta: {
              title: 'v2_service_product_info',
              routeAuthCode: 'A051901'
            }
          },
          {//常见问题
            path: 'frequentlyAskedQuestions',
            name: 'serviceFrequentlyAskedQuestions',
            component: () => import('../views/service/helpCenter/frequentlyAskedQuestions/index.vue'),
          },
          {//自助报修
            path: 'selfServiceRepair',
            name: 'serviceSelfServiceRepair',
            component: () => import('../views/service/helpCenter/selfServiceRepair/index.vue'),
          },
        ]
      },
      {//API管理
        path: 'apiManagement',
        name: 'serviceApiManagement',
        component: () => import('../views/service/apiManagement/index.vue'),
        meta: {
          title: 'v2_apiManage_ApiManagement',
          routeAuthCode: 'A0507',
        }
      },
      {//SDK接入
        path: 'sdkAccess',
        name: 'serviceSdkAccess',
        component: () => import('../views/service/sdkAccess/index.vue'),
        meta: {
          title: 'v2_SDKAccess_SDKAccess',
          routeAuthCode: 'A0512',
        }
      },
      {//发现
        path: 'discovery',
        name: 'serviceDiscovery',
        component: () => import('../views/service/discovery/index.vue'),
        meta: {
          title: 'v2_service_discover',
          routeAuthCode: 'A0511',
        }
      },
      {//第三方授权管理
        path: 'OAuth',
        name: 'serviceOAuth',
        component: () => import('../views/service/oAuth/index.vue'),
        meta: {
          title: 'v2_thirdparty_auth_management',
          routeAuthCode: 'A0516'
        }
      },
      {
        path: 'checkStand/:id',
        name: 'checkStand',
        component: () => import('../views/service/checkStand/index.vue'),
      },  // 收银台
      {
        path: 'domesticPay/:id',
        name: 'domesticPay',
        component: () => import('../views/service/checkStand/domesticPay.vue'),
      },  // 收银台 - 国内支付承载页
    ],

  },
]
